/**
 * @generated SignedSource<<d9872600432541169b37b0fe10d46324>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LogoutJwtInput = {
  clientMutationId?: string | null;
};
export type useAuthContext_LogoutMutation$variables = {
  input: LogoutJwtInput;
};
export type useAuthContext_LogoutMutation$data = {
  readonly Auth: {
    readonly logoutJwt: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type useAuthContext_LogoutMutation = {
  response: useAuthContext_LogoutMutation$data;
  variables: useAuthContext_LogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LogoutJwtPayload",
        "kind": "LinkedField",
        "name": "logoutJwt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_LogoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_LogoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "200f44eb51d6912ce7e400be1d997e64",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_LogoutMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_LogoutMutation(\n  $input: LogoutJwtInput!\n) {\n  Auth {\n    logoutJwt(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4de5ede698635ce6e1f8c5c2e729cac";

export default node;
